import { ImageCache } from './ImageCache';
import { startObserver } from './MutationObserver';

const ImageCacheExport = {
    startObserver: startObserver,
    getCached: ImageCache.getCached,
    createPromiseFailObject: ImageCache.createPromiseFailObject,
    getBlob: ImageCache.getBlob,
    blobToDataURL: ImageCache.blobToDataURL,
};

export { ImageCacheExport as ImageCache };
